// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { useEffect, useRef, useState } from "react";

function useElementDimensions<T extends HTMLElement>() {
    const elementRef = useRef<T | null>(null);
    const [size, setSize] = useState<{ width: number; height: number } | null>(null);

    useEffect(() => {
        const element = elementRef.current;
        if (!element) {
            return;
        }

        const updateSize = () => {
            setSize({
                width: element.clientWidth,
                height: element.clientHeight,
            });
        };

        const observer = new ResizeObserver(() => updateSize());
        observer.observe(element);

        // Set initial size
        updateSize();

        return () => {
            observer.disconnect();
        };
    }, [elementRef.current]);

    return [elementRef, size] as const;
}

export default useElementDimensions;
